import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const PaymentCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: 0,
        CustomerId: '',
        PaymentType: '',
        Amount: 0,
        Remarks: '',
        createdBy: userId,
        isSubmit: false,
    });

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        console.log(selectedOption);

        if (selectedOption) {
            fetchData('ReceiptApi', `/PartyPaymentBill/${selectedOption.value}/${companyId}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {
                        setInvoicedeatils(response.response_data);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });
        }

    };


    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('ReceiptApi', `/Party/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.ID,
                }));
                setCustomerOptions(options);

            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));

        if (name === 'PaymentType') {
            setSelectedPaymentType(value);
        }
    };

    const [cleaningcharge, setCleaningCharge] = useState("");
    const [otherCharge, setOtherCharge] = useState("0");



    const submitData = async (e) => {
        setIsLoading(true);

        if (!invoicedeatils.ID || invoicedeatils.ID === 0) {
            setErrorMessage('Customer is required!');
            setIsLoading(false);
            return;
        }

     

        const createData = {
            CompanyId: companyId,
            BillDate: formData.BillDate,
            CustomerId: invoicedeatils.ID,
            RoomId: invoicedeatils.RoomId,
            PaymentType: formData.PaymentType,
            CautionDeposut: invoicedeatils.CautionDeposite,
            CleaningCharge: cleaningcharge,
            OtherCharge: otherCharge,
            RefundAmount : (invoicedeatils.CautionDeposite)-(cleaningcharge)-(otherCharge),
            Remarks : formData.Remarks,
            CreatedBy : userId,

        };

        console.log('Submitting data:', createData);

        try {
            const response = await postData('CautionRefundApi', createData, token);
            setSuccessMessage('Payment Created successfully!');
            setErrorMessage('');

            history.push('/PaymentIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Receipt Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create receipt. Please try again.');
            setIsLoading(false);
        }
    };


    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);




    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);



    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '90%', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>


                <div >

                    <div className='w-full flex' style={{ marginTop: '10px' }}>

                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>CREATE PAYMENT</h6>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/PaymentIndex"
                            className="linkcolor"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkred, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}

                        >
                            BACK
                        </Button>

                        <Button
                            variant="contained"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkgreen, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-2 flex flex-wrap" style={{ marginTop: '20px' }}>
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={customerOptions}
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                placeholder="Select a customer"
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='BillDate'
                                onChange={handleChange}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.BillNo}
                                type="text"
                                placeholder="Enter BillNo"
                                name='BillNo'
                                readOnly
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Remarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='Remarks'
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={invoicedeatils.CautionDeposite !== undefined ? parseFloat(invoicedeatils.CautionDeposite).toFixed(2) : 0}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='Amount'

                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        {/* <div className="w-full sm:w-1/5 pl-2  sm:block"> 
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Cleaning Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={cleaningcharge}
                                onChange={(e) => setCleaningCharge(e.target.value)}
                                type="text"
                                placeholder="Cleaning Charge"
                                max={invoicedeatils.CautionDeposite !== 0 ? invoicedeatils.CautionDeposite : undefined}
                                style={{ textAlign: 'right' }}
                            />

                        </div> */}

                        <div className="w-full sm:w-1/5 pl-2  sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Other Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={otherCharge}
                                onChange={(e) => setOtherCharge(e.target.value)}
                                type="text"
                                placeholder="OtherCharge"
                                max={invoicedeatils.CautionDeposite !== 0 ? invoicedeatils.CautionDeposite : undefined}
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2  sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Refund Amount
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(invoicedeatils.CautionDeposite) - (cleaningcharge) - (otherCharge)}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='Amount'
                                max={invoicedeatils.CautionDeposite !== 0 ? invoicedeatils.CautionDeposite : undefined}
                                style={{ textAlign: 'right' }}
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2">
                                Payment Type
                            </label>
                            <div className="flex items-center">
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="1"
                                        checked={selectedPaymentType === "1"}
                                        onChange={handleChange} />
                                    Cash
                                </label>
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="2"
                                        checked={selectedPaymentType === "2"}
                                        onChange={handleChange} />
                                    Cheque
                                </label>
                                <label className='block  tracking-wide text-gray-700  font-bold'>
                                    <input type="radio" name="PaymentType" value="3"
                                        checked={selectedPaymentType === "3"}
                                        onChange={handleChange} />
                                    UPI
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default PaymentCreate;
